import SmallContainer from '@components/ui/layout/SmallContainer'
import { Heading, Text } from '@components/ui/typography'
import { FadeInChild } from '@components/_home/FadeInChild'
import React, { FC } from 'react'
import { AboutUsSingleton } from '__generated__/sanity'
import * as styles from './styles'

type OurStoryProps = AboutUsSingleton['fields']['ourStory']

export const OurStory: FC<OurStoryProps> = ({ ourStoryTitle, ourStoryContent }) => {
  return (
    <FadeInChild>
      <SmallContainer className={styles.container}>
        <div className={styles.content}>
          <Heading variant="h3" as="h3" mb={{ _: '2', sm: '6' }}>
            {ourStoryTitle}
          </Heading>
          <Text variant="bodyLarge">{ourStoryContent}</Text>
        </div>
      </SmallContainer>
    </FadeInChild>
  )
}
